export default __webpack_public_path__ + "static/cover-8dd168dbd7e132dc2ce542b881fbb025.png";